module.exports = __webpack_public_path__ + "static/media/sample_management.6da0efe4.png";